import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmacion-listas',
  templateUrl: './confirmacion-listas.component.html',
})
export class ConfirmacionListasComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmacionListasComponent>) {}

  confirmar() {
    this.dialogRef.close(true);
  }

  cancelar() {
    this.dialogRef.close(false);
  }
}
